export default "__VITE_PUBLIC_ASSET__67e4e5f3__"